import { type CSSObject } from "@emotion/react";
import { typographyStyles } from "@newsela/angelou";

export const tableHeaderContainerCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
};

export const headingCss: CSSObject = {
  "&&": {
    margin: 0,
    ...typographyStyles.heading3Obj,
    ...typographyStyles.fontFamily.circular,
  },
};
